import React from "react";
import i18n from "../../i18n/config";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";
import { PAGES } from "../../constants/localization";
import ShieldTick from "../../assets/images/icons/rebrand/shield-tick.svg";

// types
import { TOTPCardOwnProps } from "../../types/components/TOTP";

// ui components
import Card from "../Common/Card";
import Action from "../Common/Action";
import ActionLink from "../Common/ActionLink";
import ErrorBlock from "../Common/ErrorBlock";
import AuthenticationAppInputs from "../Common/AuthenticationAppInputs";

const TOTPCard = ({
  onSubmit,
  errors,
  resetValues,
  submitting,
  onCannotGetCode,
}: TOTPCardOwnProps) => {
  return (
    <Card
      icon={<img src={ShieldTick} alt="Shield Tick" />}
      title={i18n.t("PAGES.AUTH.TOTP.CARD.TITLE")}
      titleWeight="strong"
      wrapBody={false}
    >
      <Card.Body>
        {errors && <ErrorBlock filterErrors={false} errors={errors} />}

        <p className="auth-label bold text-secondary">{i18n.t("PAGES.AUTH.TOTP.CARD.LABEL")}</p>

        <AuthenticationAppInputs
          submitFunc={onSubmit}
          resetValues={resetValues}
          formId={PAGES.AUTH.TOTP.FORM_NAME}
          classes="full-width mb-8"
        />

        <div className="text-right">
          <ActionLink
            text={i18n.t("PAGES.AUTH.TOTP.CARD.CANNOT_GET_CODE")}
            clickFunc={onCannotGetCode}
            classes="text-blue-700 bold mt-8 underline"
          />
        </div>
      </Card.Body>

      <Card.Footer stretch stacked>
        <Action
          title={i18n.t("COMMON.CONTINUE")}
          loading={submitting}
          displayType={ACTION_DISPLAY_TYPES.PRIMARY}
          type="submit"
          formId={PAGES.AUTH.TOTP.FORM_NAME}
          dataCy="totp-submit"
          testId="totp-submit"
          size="md"
        />
      </Card.Footer>
    </Card>
  );
};

export default TOTPCard;